import {
    makeStyles,
} from 'app/tss'

const generalInformation = 'generalInformation'
const serviceCenterMetrics = 'serviceCenterMetrics'
const productMetrics = 'productMetrics'
const containerProductionRate = 'containerProductionRate'
const storages = 'storages'

const useStyles = makeStyles<{isProductionSite: boolean}>()((theme, {
    isProductionSite,
}) => {
    const gridTemplateAreas = isProductionSite ? `
                "${generalInformation} ${serviceCenterMetrics} ${serviceCenterMetrics}"
                "${productMetrics} ${productMetrics} ${containerProductionRate}"
                "${storages} ${storages} ${storages}"
                ` : `
                "${generalInformation} ${serviceCenterMetrics} ${serviceCenterMetrics}"
                "${productMetrics} ${productMetrics} ${productMetrics}"
                "${storages} ${storages} ${storages}"
                `

    return {
        gridWrapper: {
            display: 'grid',
            gap: theme.spacing(2),
            gridTemplateAreas,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        generalInformation: {
            gridArea: generalInformation,
        },
        serviceCenterMetrics: {
            gridArea: serviceCenterMetrics,
        },
        productMetrics: {
            gridArea: productMetrics,
        },
        containerProductionRate: {
            gridArea: containerProductionRate,
        },
        storages: {
            gridArea: storages,
        },
    }
})

export default useStyles
